import {useTranslation} from 'react-i18next';
import * as css from './ImageHeader.css';

function ImageHeader({text='imageText'}) {
    const {t}=useTranslation('branding');
    return (
        <css.recommendedSize>
            <span>{t(`${text}`)}</span>
            <span>{t('recommendedSize')}</span>
        </css.recommendedSize>
    );
}

export default ImageHeader;